import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { SerializedError } from '@reduxjs/toolkit';

interface ApiErrorResponse {
  error?: string;
  details?: string | string[];
}

export function getErrorMessage(
  error: FetchBaseQueryError | SerializedError | undefined,
  fallback: string,
): string {
  if (!error) return fallback;

  if ('data' in error && error.data) {
    const apiError = error.data as ApiErrorResponse;
    return apiError.error || fallback;
  }

  if ('status' in error) {
    return `Request failed with status ${error.status}`;
  }

  if ('message' in error && error.message) {
    return error.message;
  }

  return fallback;
}
